import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Box, Typography, Chip, Stack } from '@mui/material';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';
import BreadcrumbNav from '../../../../components/SEO/BreadcrumbNav';

export default function ToolHero() {
  const { t } = useTranslation();

  const breadcrumbs = [
    { label: t('breadcrumb.home', 'Inicio'), path: '/' },
    { label: t('budgetPlanner.hero.breadcrumb', 'Herramientas'), path: '/herramientas' },
    { label: t('budgetPlanner.hero.title', 'Planificador de Presupuesto') },
  ];

  const chipSx = {
    bgcolor: 'rgba(255,255,255,0.12)',
    color: 'rgba(255,255,255,0.85)',
    fontSize: '0.7rem',
    height: 26,
    border: '1px solid rgba(255,255,255,0.18)',
    '& .MuiChip-icon': { color: 'rgba(255,255,255,0.7)', fontSize: 14 },
  };

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #1A1A1A 0%, #1E3A5F 100%)',
        color: '#fff',
        py: { xs: 2.5, md: 5 },
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ mb: 1, '& a, & span': { opacity: 0.6, color: '#fff' } }}>
          <BreadcrumbNav items={breadcrumbs} />
        </Box>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 600,
            color: '#FFFFFF',
            mb: 0.5,
            lineHeight: 1.2,
            fontSize: { xs: '1.4rem', md: '2.4rem' },
          }}
        >
          {t('budgetPlanner.hero.title', 'Planificador de Presupuesto')}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: 'rgba(255,255,255,0.7)',
            fontWeight: 400,
            maxWidth: 640,
            mb: 1.5,
            fontSize: { xs: '0.85rem', md: '1.15rem' },
          }}
        >
          {t('budgetPlanner.hero.subtitle', 'Organiza tus ingresos, controla tus gastos y alcanza tus metas financieras en Canadá.')}
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Chip icon={<TimerOutlinedIcon />} label={t('budgetPlanner.hero.chip1', '60 segundos')} size="small" sx={chipSx} />
          <Chip icon={<LockOpenOutlinedIcon />} label={t('budgetPlanner.hero.chip2', 'Sin registro')} size="small" sx={chipSx} />
          <Chip icon={<VolunteerActivismOutlinedIcon />} label={t('budgetPlanner.hero.chip3', '100% gratis')} size="small" sx={chipSx} />
        </Stack>
      </Container>
    </Box>
  );
}
